webpackJsonp([15],{

/***/ 1030:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(907)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(765),
  /* template */
  __webpack_require__(1069),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-09a63dae",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1069:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "orders-product mt-3"
  }, [_c('div', {
    staticClass: "title-products font-size mb-1",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v(_vm._s(_vm.orderState) + " - NRO DE ORDEN " + _vm._s(_vm.orderNumber))]), _vm._v(" "), _c('div', {
    staticClass: "d-flex space-between wrap"
  }, [_c('div', [_c('p', {
    staticClass: "text-regular"
  }, [_vm._v("Precio Total: "), _c('span', {
    staticClass: "text-bold font-size"
  }, [_vm._v("PEN " + _vm._s(_vm.orderTotal))])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-regular"
  }, [_vm._v("Fecha de la Orden: "), _c('span', {
    staticClass: "text-bold font-size"
  }, [_vm._v(_vm._s(_vm.orderDate))])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-regular"
  }, [_vm._v("Estado: "), _c('span', {
    staticClass: "text-bold font-size"
  }, [_vm._v(_vm._s(_vm.orderPaymentStateName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom"
  }, [_c('p', {
    staticClass: "text-regular"
  }, [_vm._v("Direccion de envío : "), _c('span', {
    staticClass: "text-bold font-size"
  }, [_vm._v(_vm._s(_vm.orderWarehouseAddress))])])])]), _vm._v(" "), _c('div', {
    staticClass: "voucher-section"
  }, [_c('p', {
    staticClass: "title-deposit-data",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("DATOS DE DEPOSITO")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex space-between"
  }, [_c('div', {
    staticClass: "wrapper-list-item"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.deposit
    }
  }, [_c('el-form-item', {
    staticClass: "mb-2"
  }, [_c('el-input', {
    staticClass: "qtc-input",
    attrs: {
      "placeholder": "Nro de Deposito"
    },
    model: {
      value: (_vm.deposit.number),
      callback: function($$v) {
        _vm.$set(_vm.deposit, "number", $$v)
      },
      expression: "deposit.number"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "mb-2"
  }, [_c('el-input', {
    staticClass: "qtc-input",
    attrs: {
      "placeholder": "Foto de Voucher"
    },
    model: {
      value: (_vm.deposit.voucher),
      callback: function($$v) {
        _vm.$set(_vm.deposit, "voucher", $$v)
      },
      expression: "deposit.voucher"
    }
  }), _vm._v(" "), _c('div', [_c('input', {
    ref: "upLoadAvatar",
    attrs: {
      "hidden": "",
      "type": "file",
      "accept": _vm.allowedFiles
    },
    on: {
      "change": _vm.upLoadAvatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mask d-flex align-center justify-center",
    style: (("background-color:" + (_vm.globalColors.primary))),
    on: {
      "click": _vm.maskFn
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.loadAvatarBtn,
      "alt": "",
      "width": "22",
      "height": "20"
    }
  })])])], 1)], 1)], 1), _vm._v(" "), (_vm.deposit.voucher) ? _c('img', {
    staticClass: "voucher-image",
    attrs: {
      "src": _vm.deposit.voucher,
      "alt": "contanciar de pago"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex-95 d-flex align-center justify-center"
  }, [_c('button', {
    staticClass: "btn-deposit",
    style: (("background-color:" + (_vm.globalColors.secondary))),
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goTo('orders')
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn-deposit",
    style: (("background-color:" + (_vm.globalColors.primary))),
    attrs: {
      "disabled": !(_vm.deposit.voucher && _vm.deposit.number),
      "type": "button"
    },
    on: {
      "click": _vm.updateVoucher
    }
  }, [_vm._v("Guardar")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1091:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('deposit-data', {
    attrs: {
      "order": _vm.order
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(766),
  /* template */
  __webpack_require__(1091),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 765:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_lib__ = __webpack_require__(37);




var updateVoucher = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var headers, body, id;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						headers = {
							Authorization: 'Bearer ' + this.token
						};
						body = {
							depositNumber: this.deposit.number,
							urlVoucher: this.deposit.voucher
						};
						id = this.$route.params.id;
						_context.prev = 3;
						_context.next = 6;
						return this.$httpJapi.patch('orders/' + id + '/voucher', body, { headers: headers });

					case 6:
						this.$message.success({ message: 'Datos enviado exitosamente', showClose: true });
						this.goTo('orders');
						_context.next = 13;
						break;

					case 10:
						_context.prev = 10;
						_context.t0 = _context['catch'](3);

						this.$message({
							message: 'Error',
							showClose: true,
							type: 'error'
						});

					case 13:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[3, 10]]);
	}));

	return function updateVoucher() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var getDeeper = __WEBPACK_IMPORTED_MODULE_4__helpers_lib__["a" /* default */].getDeeper;


function orderHandler(order) {
	var additionalInfo = order.additionalInfo;

	if (additionalInfo) {
		this.deposit.number = additionalInfo.depositNumber;
		this.deposit.voucher = additionalInfo.urlVoucher;
	}
}

function orderWarehouseAddress() {
	return getDeeper('warehouseAddress')(this.order);
}

function orderPaymentStateName() {
	return getDeeper('paymentStateName')(this.order);
}

function orderState() {
	return getDeeper('orderState.name')(this.order);
}

function orderNumber() {
	return getDeeper('number')(this.order);
}

function upLoadAvatar() {
	var _this = this;

	var reader = new FileReader();
	var file = this.$refs.upLoadAvatar.files[0];
	reader.onload = function (evt) {
		var fileData = {
			name: file.name.replace(/\s/g, '-'),
			base64data: evt.target.result
		};
		var headers = {
			Authorization: 'Bearer ' + _this.token
		};
		_this.$httpUpLoad.post('upload-files', fileData, { headers: headers }).then(function (response) {
			_this.deposit.voucher = response.data.Location;
		}).catch(function () {
			_this.$message({
				message: 'No es posible cargar ese archivo',
				showClose: true,
				type: 'error'
			});
		});
	};
	reader.readAsDataURL(file);
}

function goTo(name) {
	this.$router.push({ name: name });
}

function maskFn() {
	this.$refs.upLoadAvatar.click();
}

function orderTotal() {
	return getDeeper('total')(this.order);
}

function orderDate() {
	var date = getDeeper('createdAt')(this.order);
	var day = new Date(date).getDay();
	var month = new Date(date).getMonth() + 1;
	var year = new Date(date).getFullYear();
	return day + '-' + month + '-' + year;
}

function data() {
	return {
		allowedFiles: '.svg,.png,.jpg,.jpeg,.svg',
		loadAvatarBtn: '/static/img/icons/camera.svg',
		deposit: {
			number: null,
			voucher: null
		}
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	data: data,
	name: 'deposit-data',
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		orderDate: orderDate,
		orderNumber: orderNumber,
		orderPaymentStateName: orderPaymentStateName,
		orderState: orderState,
		orderTotal: orderTotal,
		orderWarehouseAddress: orderWarehouseAddress
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getUserInfo', 'token'])),
	methods: {
		goTo: goTo,
		maskFn: maskFn,
		orderHandler: orderHandler,
		upLoadAvatar: upLoadAvatar,
		updateVoucher: updateVoucher
	},
	props: {
		order: {
			default: function _default() {},
			type: Object
		}
	},
	watch: {
		order: {
			deep: true,
			handler: orderHandler
		}
	}
});

/***/ }),

/***/ 766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profile_orders_deposit_data__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_profile_orders_deposit_data___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_profile_orders_deposit_data__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(9);





var loadData = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
		var headers, url, _ref2;

		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						headers = {
							Authorization: 'Bearer ' + this.token
						};
						url = 'orders/' + this.id;
						_context.next = 4;
						return this.$httpJapi(url, { headers: headers });

					case 4:
						_ref2 = _context.sent;
						this.order = _ref2.data;

						this.rowsProduct = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.order.details));

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//




function created() {
	this.id = this.$route.params.id;

	this.loadData();
}

function data() {
	return {
		id: 0,
		order: {},
		rowsProduct: []
	};
}

/* harmony default export */ __webpack_exports__["default"] = ({
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['token'])),
	created: created,
	data: data,
	name: 'deposit',
	methods: {
		loadData: loadData
	},
	components: {
		depositData: __WEBPACK_IMPORTED_MODULE_4__components_profile_orders_deposit_data___default.a
	}
});

/***/ }),

/***/ 828:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(414)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Opens_regular;src:url(\"/static/fonts/OpenSans/OpenSans-Regular.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Opens_bold;src:url(\"/static/fonts/OpenSans/OpenSans-Bold.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Opens_semibold;src:url(\"/static/fonts/OpenSans/OpenSans-SemiBold.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:Opens_light;src:url(\"/static/fonts/OpenSans/OpenSans-Light.ttf\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirMedium;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirBold;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");font-weight:400;font-display:swap;font-style:normal}@font-face{font-family:AvenirDemi;src:url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");font-weight:400;font-display:swap;font-style:normal}.absolute[data-v-09a63dae]{position:absolute}.align-center[data-v-09a63dae]{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.align-start[data-v-09a63dae]{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}.align-end[data-v-09a63dae]{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.bgWhite[data-v-09a63dae]{background-color:#fff}.black[data-v-09a63dae]{color:#e9d628}.block[data-v-09a63dae]{display:block}.bold[data-v-09a63dae]{font-weight:700}.d-flex[data-v-09a63dae]{display:-webkit-box;display:-ms-flexbox;display:flex}.disabled-btn[data-v-09a63dae]{cursor:not-allowed;opacity:.25}.flex-column[data-v-09a63dae]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.flex-5[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 5%;flex:1 1 5%}.flex-10[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 10%;flex:1 1 10%}.flex-15[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 15%;flex:1 1 15%}.flex-25[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 25%;flex:1 1 25%}.flex-20[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 20%;flex:1 1 20%}.flex-30[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 30%;flex:1 1 30%}.flex-40[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 40%;flex:1 1 40%}.flex-45[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 45%;flex:1 1 45%}.flex-50[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%}.flex-60[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 60%;flex:1 1 60%}.flex-65[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 65%;flex:1 1 65%}.flex-70[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 70%;flex:1 1 70%}.flex-80[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 80%;flex:1 1 80%}.flex-95[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 95%;flex:1 1 95%}.flex-auto[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}.fontAvenir[data-v-09a63dae]{font-family:AvenirMedium}.fontAvenirBold[data-v-09a63dae]{font-family:AvenirBold}.fontOpenBold[data-v-09a63dae]{font-family:Opens_semibold}.fontAvenirDemi[data-v-09a63dae]{font-family:AvenirDemi}.fontS10[data-v-09a63dae]{font-size:1rem}.fontS11[data-v-09a63dae]{font-size:1.1rem}.fontS12[data-v-09a63dae]{font-size:1.2rem}.fontS13[data-v-09a63dae]{font-size:1.3rem}.fontS14[data-v-09a63dae]{font-size:1.4rem}.fontS16[data-v-09a63dae]{font-size:1.6rem}.fontS20[data-v-09a63dae]{font-size:2rem}.h-100[data-v-09a63dae]{height:100%}.justify-center[data-v-09a63dae]{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.justify-end[data-v-09a63dae]{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.justify-start[data-v-09a63dae]{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.justify-text[data-v-09a63dae]{text-align:justify}.line-height-2[data-v-09a63dae]{line-height:2rem}.m0[data-v-09a63dae]{margin:0}.m-auto[data-v-09a63dae]{margin:auto}.mb-1[data-v-09a63dae]{margin-bottom:1rem}.mb-2[data-v-09a63dae]{margin-bottom:2rem}.mb-3[data-v-09a63dae]{margin-bottom:3rem}.mb-4[data-v-09a63dae]{margin-bottom:4rem}.mb-6[data-v-09a63dae]{margin-bottom:6rem}.mr-1[data-v-09a63dae]{margin-right:1rem}.mr-2[data-v-09a63dae]{margin-right:2rem}.mr-3[data-v-09a63dae]{margin-right:3rem}.mx-1[data-v-09a63dae]{margin-left:1rem;margin-right:1rem}.mx-2[data-v-09a63dae]{margin-left:2rem;margin-right:2rem}.mx-3[data-v-09a63dae]{margin-left:3rem;margin-right:3rem}.my-0[data-v-09a63dae]{margin-bottom:0;margin-top:0}.my-1[data-v-09a63dae]{margin-bottom:1rem;margin-top:1rem}.my-2[data-v-09a63dae]{margin-bottom:2rem;margin-top:2rem}.my-3[data-v-09a63dae]{margin-bottom:3rem;margin-top:3rem}.my-4[data-v-09a63dae]{margin-bottom:4rem;margin-top:4rem}.mt-1[data-v-09a63dae]{margin-top:1rem}.mt-2[data-v-09a63dae]{margin-top:2rem}.mt-3[data-v-09a63dae]{margin-top:3rem}.mt-4[data-v-09a63dae]{margin-top:4rem}.mt-5[data-v-09a63dae]{margin-top:5rem}.ml-1[data-v-09a63dae]{margin-left:1rem}.ml-2[data-v-09a63dae]{margin-left:2rem}.ml-3[data-v-09a63dae]{margin-left:3rem}.mw-100[data-v-09a63dae]{min-width:100%}.orange[data-v-09a63dae]{color:#f703ff}.pb-1[data-v-09a63dae]{padding-bottom:1rem}.pb-2[data-v-09a63dae]{padding-bottom:2rem}.pb-3[data-v-09a63dae]{padding-bottom:3rem}.pt-2[data-v-09a63dae]{padding-top:2rem}.pt-3[data-v-09a63dae]{padding-top:3rem}.pt-4[data-v-09a63dae]{padding-top:4rem}.px-1[data-v-09a63dae]{padding:0 1rem}.px-2[data-v-09a63dae]{padding:0 2rem}.px-3[data-v-09a63dae]{padding-left:3rem;padding-right:3rem}.px-4[data-v-09a63dae]{padding:0 4rem}.px-5[data-v-09a63dae]{padding-left:5rem;padding-right:5rem}.px-8[data-v-09a63dae]{padding-left:8rem;padding-right:8rem}.py-1[data-v-09a63dae]{padding:1rem 0}.py-2[data-v-09a63dae]{padding-top:2rem;padding-bottom:2rem}.py-3[data-v-09a63dae]{padding-top:3rem;padding-bottom:3rem}.py-4[data-v-09a63dae]{padding-top:4rem;padding-bottom:4rem}.p2[data-v-09a63dae]{padding:2rem}.p4[data-v-09a63dae]{padding:4rem}.p6[data-v-09a63dae]{padding:6rem}.relative[data-v-09a63dae]{position:relative}.space-around[data-v-09a63dae]{-ms-flex-pack:distribute;justify-content:space-around}.space-evenly[data-v-09a63dae]{-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}.space-between[data-v-09a63dae]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.txt-center[data-v-09a63dae]{text-align:center}.txt-left[data-v-09a63dae]{text-align:left}.txt-right[data-v-09a63dae]{text-align:right}.uppercase[data-v-09a63dae]{text-transform:uppercase}.w-100[data-v-09a63dae]{width:100%}.w-51[data-v-09a63dae]{width:51%}.white-space[data-v-09a63dae]{white-space:nowrap}.wrap[data-v-09a63dae]{-ms-flex-wrap:wrap;flex-wrap:wrap}.title-deposit-data[data-v-09a63dae]{font-family:AvenirBold;font-size:1.6rem;margin:0 0 3.5rem 1rem}.btn-deposit[data-v-09a63dae]{border:none;color:#ffff;font-family:AvenirDemi;font-size:2rem;margin:1rem;padding:1.5rem 3rem}.btn-deposit[data-v-09a63dae]:disabled{cursor:not-allowed;opacity:.3}.wrapper-list-item[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;padding:0 2rem}.mask[data-v-09a63dae]{border-top-right-radius:.4rem;border-bottom-right-radius:.4rem;bottom:0;cursor:pointer;height:4.6rem;position:absolute;right:0;width:5.6rem}.orders-product[data-v-09a63dae]{font-size:1.4rem;padding:0 5rem}.title-products[data-v-09a63dae]{font-weight:700}.font-size[data-v-09a63dae]{font-size:1.4rem}.border-bottom[data-v-09a63dae]{border-bottom:.2em solid #f1f1f1}.text-bold[data-v-09a63dae]{font-weight:700}.text-regular[data-v-09a63dae]{font-weight:400}.voucher-section[data-v-09a63dae]{padding:2rem 4rem}.voucher-image[data-v-09a63dae]{-webkit-box-flex:1;-ms-flex:1 1 10%;flex:1 1 10%;padding:0 2rem;max-width:22rem;-o-object-fit:contain;object-fit:contain}", "", {"version":3,"sources":["/opt/build/repo/src/components/profile/orders/deposit-data.vue"],"names":[],"mappings":"AACA,WACE,0BAA6B,AAC7B,uDAAwD,AACxD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,oDAAqD,AACrD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,wDAAyD,AACzD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,qDAAsD,AACtD,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,yBAA4B,AAC5B,6DAA8D,AAC9D,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,0DAA2D,AAC3D,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,WACE,uBAA0B,AAC1B,0DAA2D,AAC3D,gBAAoB,AACpB,kBAAmB,AACnB,iBAAmB,CACpB,AACD,2BACE,iBAAmB,CACpB,AACD,+BACE,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC7B,AACD,8BACE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,4BACE,sBAAuB,AACnB,mBAAoB,AAChB,oBAAsB,CAC/B,AACD,0BACE,qBAAwB,CACzB,AACD,wBACE,aAAe,CAChB,AACD,wBACE,aAAe,CAChB,AACD,uBACE,eAAkB,CACnB,AACD,yBACE,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACf,AACD,+BACE,mBAAoB,AACpB,WAAc,CACf,AACD,8BACE,4BAA6B,AAC7B,6BAA8B,AAC1B,0BAA2B,AACvB,qBAAuB,CAChC,AACD,yBACE,mBAAoB,AAChB,gBAAiB,AACb,WAAa,CACtB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,0BACE,mBAAoB,AAChB,iBAAkB,AACd,YAAc,CACvB,AACD,4BACE,mBAAoB,AAChB,kBAAmB,AACf,aAAe,CACxB,AACD,6BACE,wBAA4B,CAC7B,AACD,iCACE,sBAA0B,CAC3B,AACD,+BACE,0BAA8B,CAC/B,AACD,iCACE,sBAA0B,CAC3B,AACD,0BACE,cAAgB,CACjB,AACD,0BACE,gBAAkB,CACnB,AAID,0BACE,gBAAkB,CACnB,AACD,0BACE,gBAAkB,CACnB,AACD,0BACE,gBAAkB,CACnB,AACD,0BACE,gBAAkB,CACnB,AACD,0BACE,cAAgB,CACjB,AACD,wBACE,WAAa,CACd,AACD,iCACE,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,8BACE,qBAAsB,AAClB,kBAAmB,AACf,wBAA0B,CACnC,AACD,gCACE,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACrC,AACD,+BACE,kBAAoB,CACrB,AACD,gCACE,gBAAkB,CACnB,AACD,qBACE,QAAU,CACX,AACD,yBACE,WAAa,CACd,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,kBAAoB,CACrB,AACD,uBACE,iBAAmB,CACpB,AACD,uBACE,iBAAmB,CACpB,AACD,uBACE,iBAAmB,CACpB,AACD,uBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,uBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,uBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,uBACE,gBAAiB,AACjB,YAAc,CACf,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,eAAiB,CAClB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,yBACE,cAAgB,CACjB,AACD,yBACE,aAAe,CAChB,AACD,uBACE,mBAAqB,CACtB,AACD,uBACE,mBAAqB,CACtB,AACD,uBACE,mBAAqB,CACtB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,uBACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,uBACE,cAAgB,CACjB,AACD,uBACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,uBACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,uBACE,iBAAkB,AAClB,mBAAqB,CACtB,AACD,qBACE,YAAc,CACf,AACD,qBACE,YAAc,CACf,AACD,qBACE,YAAc,CACf,AACD,2BACE,iBAAmB,CACpB,AACD,+BACE,yBAA0B,AACtB,4BAA8B,CACnC,AACD,+BACE,8BAA+B,AAC3B,2BAA4B,AACxB,4BAA8B,CACvC,AACD,gCACE,yBAA0B,AACtB,sBAAuB,AACnB,6BAA+B,CACxC,AACD,6BACE,iBAAmB,CACpB,AACD,2BACE,eAAiB,CAClB,AACD,4BACE,gBAAkB,CACnB,AACD,4BACE,wBAA0B,CAC3B,AACD,wBACE,UAAY,CACb,AACD,uBACE,SAAW,CACZ,AACD,8BACE,kBAAoB,CACrB,AACD,uBACE,mBAAoB,AAChB,cAAgB,CACrB,AACD,qCACE,uBAA0B,AAC1B,iBAAkB,AAClB,sBAAwB,CACzB,AACD,8BACE,YAAa,AACb,YAAa,AACb,uBAA0B,AAC1B,eAAgB,AAChB,YAAa,AACb,mBAAqB,CACtB,AACD,uCACE,mBAAoB,AACpB,UAAa,CACd,AACD,oCACE,mBAAoB,AAChB,iBAAkB,AACd,aAAc,AACtB,cAAgB,CACjB,AACD,uBACE,8BAAgC,AAChC,iCAAmC,AACnC,SAAa,AACb,eAAgB,AAChB,cAAe,AACf,kBAAmB,AACnB,QAAS,AACT,YAAc,CACf,AACD,iCACE,iBAAkB,AAClB,cAAmB,CACpB,AACD,iCACE,eAAkB,CACnB,AACD,4BACE,gBAAkB,CACnB,AACD,gCACE,gCAAmC,CACpC,AACD,4BACE,eAAkB,CACnB,AACD,+BACE,eAAoB,CACrB,AACD,kCACE,iBAAmB,CACpB,AACD,gCACE,mBAAoB,AAChB,iBAAkB,AACd,aAAc,AACtB,eAAgB,AAChB,gBAAiB,AACjB,sBAAuB,AACpB,kBAAoB,CACxB","file":"deposit-data.vue","sourcesContent":["\n@font-face {\n  font-family: 'Opens_regular';\n  src: url(\"/static/fonts/OpenSans/OpenSans-Regular.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_bold';\n  src: url(\"/static/fonts/OpenSans/OpenSans-Bold.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_semibold';\n  src: url(\"/static/fonts/OpenSans/OpenSans-SemiBold.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'Opens_light';\n  src: url(\"/static/fonts/OpenSans/OpenSans-Light.ttf\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'AvenirMedium';\n  src: url(\"/static/fonts/Avenir/AvenirNextLTPro-Regular.woff\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'AvenirBold';\n  src: url(\"/static/fonts/Avenir/AvenirNextLTPro-Bold.woff\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'AvenirDemi';\n  src: url(\"/static/fonts/Avenir/AvenirNextLTPro-Demi.woff\");\n  font-weight: normal;\n  font-display: swap;\n  font-style: normal;\n}\n.absolute[data-v-09a63dae] {\n  position: absolute;\n}\n.align-center[data-v-09a63dae] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.align-start[data-v-09a63dae] {\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.align-end[data-v-09a63dae] {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n.bgWhite[data-v-09a63dae] {\n  background-color: white;\n}\n.black[data-v-09a63dae] {\n  color: #e9d628;\n}\n.block[data-v-09a63dae] {\n  display: block;\n}\n.bold[data-v-09a63dae] {\n  font-weight: bold;\n}\n.d-flex[data-v-09a63dae] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.disabled-btn[data-v-09a63dae] {\n  cursor: not-allowed;\n  opacity: 0.25;\n}\n.flex-column[data-v-09a63dae] {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.flex-5[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 5%;\n          flex: 1 1 5%;\n}\n.flex-10[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 10%;\n          flex: 1 1 10%;\n}\n.flex-15[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 15%;\n          flex: 1 1 15%;\n}\n.flex-25[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 25%;\n          flex: 1 1 25%;\n}\n.flex-20[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 20%;\n          flex: 1 1 20%;\n}\n.flex-30[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 30%;\n          flex: 1 1 30%;\n}\n.flex-40[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 40%;\n          flex: 1 1 40%;\n}\n.flex-45[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 45%;\n          flex: 1 1 45%;\n}\n.flex-50[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 50%;\n          flex: 1 1 50%;\n}\n.flex-60[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 60%;\n          flex: 1 1 60%;\n}\n.flex-65[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 65%;\n          flex: 1 1 65%;\n}\n.flex-70[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 70%;\n          flex: 1 1 70%;\n}\n.flex-80[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 80%;\n          flex: 1 1 80%;\n}\n.flex-95[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 95%;\n          flex: 1 1 95%;\n}\n.flex-auto[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n}\n.fontAvenir[data-v-09a63dae] {\n  font-family: \"AvenirMedium\";\n}\n.fontAvenirBold[data-v-09a63dae] {\n  font-family: \"AvenirBold\";\n}\n.fontOpenBold[data-v-09a63dae] {\n  font-family: \"Opens_semibold\";\n}\n.fontAvenirDemi[data-v-09a63dae] {\n  font-family: \"AvenirDemi\";\n}\n.fontS10[data-v-09a63dae] {\n  font-size: 1rem;\n}\n.fontS11[data-v-09a63dae] {\n  font-size: 1.1rem;\n}\n.fontS13[data-v-09a63dae] {\n  font-size: 1.3rem;\n}\n.fontS12[data-v-09a63dae] {\n  font-size: 1.2rem;\n}\n.fontS13[data-v-09a63dae] {\n  font-size: 1.3rem;\n}\n.fontS14[data-v-09a63dae] {\n  font-size: 1.4rem;\n}\n.fontS16[data-v-09a63dae] {\n  font-size: 1.6rem;\n}\n.fontS20[data-v-09a63dae] {\n  font-size: 2rem;\n}\n.h-100[data-v-09a63dae] {\n  height: 100%;\n}\n.justify-center[data-v-09a63dae] {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.justify-end[data-v-09a63dae] {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n.justify-start[data-v-09a63dae] {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n.justify-text[data-v-09a63dae] {\n  text-align: justify;\n}\n.line-height-2[data-v-09a63dae] {\n  line-height: 2rem;\n}\n.m0[data-v-09a63dae] {\n  margin: 0;\n}\n.m-auto[data-v-09a63dae] {\n  margin: auto;\n}\n.mb-1[data-v-09a63dae] {\n  margin-bottom: 1rem;\n}\n.mb-2[data-v-09a63dae] {\n  margin-bottom: 2rem;\n}\n.mb-3[data-v-09a63dae] {\n  margin-bottom: 3rem;\n}\n.mb-4[data-v-09a63dae] {\n  margin-bottom: 4rem;\n}\n.mb-6[data-v-09a63dae] {\n  margin-bottom: 6rem;\n}\n.mr-1[data-v-09a63dae] {\n  margin-right: 1rem;\n}\n.mr-2[data-v-09a63dae] {\n  margin-right: 2rem;\n}\n.mr-3[data-v-09a63dae] {\n  margin-right: 3rem;\n}\n.mx-1[data-v-09a63dae] {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n.mx-2[data-v-09a63dae] {\n  margin-left: 2rem;\n  margin-right: 2rem;\n}\n.mx-3[data-v-09a63dae] {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n.my-0[data-v-09a63dae] {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.my-1[data-v-09a63dae] {\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n}\n.my-2[data-v-09a63dae] {\n  margin-bottom: 2rem;\n  margin-top: 2rem;\n}\n.my-3[data-v-09a63dae] {\n  margin-bottom: 3rem;\n  margin-top: 3rem;\n}\n.my-4[data-v-09a63dae] {\n  margin-bottom: 4rem;\n  margin-top: 4rem;\n}\n.mt-1[data-v-09a63dae] {\n  margin-top: 1rem;\n}\n.mt-2[data-v-09a63dae] {\n  margin-top: 2rem;\n}\n.mt-3[data-v-09a63dae] {\n  margin-top: 3rem;\n}\n.mt-4[data-v-09a63dae] {\n  margin-top: 4rem;\n}\n.mt-5[data-v-09a63dae] {\n  margin-top: 5rem;\n}\n.ml-1[data-v-09a63dae] {\n  margin-left: 1rem;\n}\n.ml-2[data-v-09a63dae] {\n  margin-left: 2rem;\n}\n.ml-3[data-v-09a63dae] {\n  margin-left: 3rem;\n}\n.mw-100[data-v-09a63dae] {\n  min-width: 100%;\n}\n.orange[data-v-09a63dae] {\n  color: #f703ff;\n}\n.pb-1[data-v-09a63dae] {\n  padding-bottom: 1rem;\n}\n.pb-2[data-v-09a63dae] {\n  padding-bottom: 2rem;\n}\n.pb-3[data-v-09a63dae] {\n  padding-bottom: 3rem;\n}\n.pt-2[data-v-09a63dae] {\n  padding-top: 2rem;\n}\n.pt-3[data-v-09a63dae] {\n  padding-top: 3rem;\n}\n.pt-4[data-v-09a63dae] {\n  padding-top: 4rem;\n}\n.px-1[data-v-09a63dae] {\n  padding: 0 1rem;\n}\n.px-2[data-v-09a63dae] {\n  padding: 0 2rem;\n}\n.px-3[data-v-09a63dae] {\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n.px-4[data-v-09a63dae] {\n  padding: 0 4rem;\n}\n.px-5[data-v-09a63dae] {\n  padding-left: 5rem;\n  padding-right: 5rem;\n}\n.px-8[data-v-09a63dae] {\n  padding-left: 8rem;\n  padding-right: 8rem;\n}\n.py-1[data-v-09a63dae] {\n  padding: 1rem 0;\n}\n.py-2[data-v-09a63dae] {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n.py-3[data-v-09a63dae] {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n.py-4[data-v-09a63dae] {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n.p2[data-v-09a63dae] {\n  padding: 2rem;\n}\n.p4[data-v-09a63dae] {\n  padding: 4rem;\n}\n.p6[data-v-09a63dae] {\n  padding: 6rem;\n}\n.relative[data-v-09a63dae] {\n  position: relative;\n}\n.space-around[data-v-09a63dae] {\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.space-evenly[data-v-09a63dae] {\n  -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n          justify-content: space-evenly;\n}\n.space-between[data-v-09a63dae] {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.txt-center[data-v-09a63dae] {\n  text-align: center;\n}\n.txt-left[data-v-09a63dae] {\n  text-align: left;\n}\n.txt-right[data-v-09a63dae] {\n  text-align: right;\n}\n.uppercase[data-v-09a63dae] {\n  text-transform: uppercase;\n}\n.w-100[data-v-09a63dae] {\n  width: 100%;\n}\n.w-51[data-v-09a63dae] {\n  width: 51%;\n}\n.white-space[data-v-09a63dae] {\n  white-space: nowrap;\n}\n.wrap[data-v-09a63dae] {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.title-deposit-data[data-v-09a63dae] {\n  font-family: \"AvenirBold\";\n  font-size: 1.6rem;\n  margin: 0 0 3.5rem 1rem;\n}\n.btn-deposit[data-v-09a63dae] {\n  border: none;\n  color: #ffff;\n  font-family: \"AvenirDemi\";\n  font-size: 2rem;\n  margin: 1rem;\n  padding: 1.5rem 3rem;\n}\n.btn-deposit[data-v-09a63dae]:disabled {\n  cursor: not-allowed;\n  opacity: 0.3;\n}\n.wrapper-list-item[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 50%;\n          flex: 1 1 50%;\n  padding: 0 2rem;\n}\n.mask[data-v-09a63dae] {\n  border-top-right-radius: 0.4rem;\n  border-bottom-right-radius: 0.4rem;\n  bottom: 0rem;\n  cursor: pointer;\n  height: 4.6rem;\n  position: absolute;\n  right: 0;\n  width: 5.6rem;\n}\n.orders-product[data-v-09a63dae] {\n  font-size: 1.4rem;\n  padding: 0rem 5rem;\n}\n.title-products[data-v-09a63dae] {\n  font-weight: bold;\n}\n.font-size[data-v-09a63dae] {\n  font-size: 1.4rem;\n}\n.border-bottom[data-v-09a63dae] {\n  border-bottom: 0.2em solid #f1f1f1;\n}\n.text-bold[data-v-09a63dae] {\n  font-weight: bold;\n}\n.text-regular[data-v-09a63dae] {\n  font-weight: normal;\n}\n.voucher-section[data-v-09a63dae] {\n  padding: 2rem 4rem;\n}\n.voucher-image[data-v-09a63dae] {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 10%;\n          flex: 1 1 10%;\n  padding: 0 2rem;\n  max-width: 22rem;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(828);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(415)("4c40e4ee", content, true);

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.c746a9f87cb33bf936aa.js